<script lang="ts" module>
	export type ButtonProps = BaseButtonProps & {
		loading?: boolean;
		loadingText?: string;
		disabled?: boolean;
		spinnerClass?: string | undefined;
		size?: SizeType;
	};
</script>

<script lang="ts">
	import { Button, Spinner, type SizeType } from "flowbite-svelte";
	import { twMerge } from "tailwind-merge";
	import type { ButtonProps as BaseButtonProps } from "flowbite-svelte/Button.svelte";

	type $$Props = ButtonProps;

	// This is a workaround for Flowbite Svelte not having a uniform size across
	// alternative and primary variants
	const sizeToPx = {
		xs: "h-[34px]",
		sm: "h-[38px]",
		md: "h-[42px]",
		lg: "h-[50px]",
		xl: "h-[54px]",
	};

	export let loading = false;
	export let loadingText = "Loading...";
	export let disabled = false;
	export let spinnerClass: string | undefined = undefined;
	export let size: SizeType = "md";

	$: spinnerSize = {
		xs: "3",
		sm: "3",
		md: "4",
		lg: "6",
		xl: "6",
	}[size];
</script>

<!-- eslint-disable-next-line custom/no-button-without-data-action-name -->
<Button class={twMerge(sizeToPx[size], $$props.class)} {...$$restProps} {size} disabled={disabled || loading} on:click on:change on:keydown on:keyup on:touchstart on:touchend on:touchcancel on:mousedown on:mouseenter on:mouseleave>
	{#if loading}
		<div class="relative flex h-full w-full items-center justify-center">
			<div class="invisible">
				<slot />
			</div>
			<div role="status" class={twMerge("absolute", spinnerClass)}>
				<slot name="loading-indicator">
					<Spinner size={spinnerSize} aria-hidden={true} />
				</slot>
				<span class="sr-only">{loadingText}</span>
			</div>
		</div>
	{:else}
		<slot />
	{/if}
</Button>
